import {ObjectColumn, ObjectConfig} from './object-column.model';

export class DropdownColumn extends ObjectColumn {

  constructor(title,
              config: DropdownConfig) {
    super(title,
      {
        property: config.property,
        limit: config.limit,
        subProperty: config.subProperty,
      });
    this._columnType = 'DropdownColumn';
  }

  get(element: any): any {
    return super.get(element);
  }
}

export interface DropdownConfig extends ObjectConfig {
}
